__turbopack_context__.v({
  "em-sig-button": "OnboardingEmailSignatureEditor-module-scss-module__3C3pAa__em-sig-button",
  "em-sig-editor": "OnboardingEmailSignatureEditor-module-scss-module__3C3pAa__em-sig-editor",
  "em-sig-editor-panels": "OnboardingEmailSignatureEditor-module-scss-module__3C3pAa__em-sig-editor-panels",
  "em-sig-preview-container": "OnboardingEmailSignatureEditor-module-scss-module__3C3pAa__em-sig-preview-container",
  "em-sig-preview-section": "OnboardingEmailSignatureEditor-module-scss-module__3C3pAa__em-sig-preview-section",
  "em-sig-submission-buttons-container": "OnboardingEmailSignatureEditor-module-scss-module__3C3pAa__em-sig-submission-buttons-container",
  "em-sig-submission-container": "OnboardingEmailSignatureEditor-module-scss-module__3C3pAa__em-sig-submission-container",
});
